import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";
import createSagaMiddleware from "redux-saga";

import { rootReducer, rootSaga } from "./rootDuck";

const isProd = process.env.NODE_ENV === "production";
if (isProd) {
  delete window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const sagaMiddleware = createSagaMiddleware();
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk, sagaMiddleware)),
);

sagaMiddleware.run(rootSaga);

export default store;
